import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Divider, Paper, Stack, Typography } from "@mui/material";
import { allIcons } from "../../../assets";
import AdminList from "./AdminList";
import { t } from "i18next";

const style = {
  searchField: {
    "& .MuiOutlinedInput-root": {
      borderRadius: 2,
      backgroundColor: "#F3F3F3",
      "& .MuiOutlinedInput-notchedOutline": {
        border: `none`,
        boxShadow: "none",
      },
      "&:hover .MuiOutlinedInput-notchedOutline": {
        border: `none`,
      },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        border: `none`,
      },
    },
  },
};

function ListBox({ socket }) {
  return (
    <Paper sx={{ borderRadius: "10px" }}>
      {/* header */}
      <Stack p={2} gap={1.5} direction={"row"} alignItems={"center"}>
        <img
          src={allIcons.handshakeInactiveIcon}
          alt="handshake-icon"
          width={30}
        />
        <Stack direction={"row"} alignItems={"center"}>
          <Typography variant="h1" fontSize={"1.125rem"} fontWeight={"bold"}>
            {t("messages")}
          </Typography>
          <ExpandMoreIcon />
        </Stack>
      </Stack>

      <Divider />

      <Stack p={2} gap={1.5} height={"65vh"} overflow={"auto"}>
        <AdminList socket={socket} />
      </Stack>
    </Paper>
  );
}

export default ListBox;
